export const rules = {
  minLength: { regex: /.{12,}/, label: 'At least 12 characters (must be met)' },
  hasNumber: { regex: /[0-9]/, label: 'Should contain at least one number' },
  hasSpecialChar: {
    regex: /[!@#$%^&*(),.?":{}|<>]/,
    label: 'Should contain at least one special character'
  },
  hasUppercase: { regex: /[A-Z]/, label: 'Should contain at least one uppercase letter' },
  hasLowercase: { regex: /[a-z]/, label: 'Should contain at least one lowercase letter' }
}

export const getInitialRequirements = () =>
  Object.entries(rules).map(([, { label }]) => ({
    label,
    isMet: false
  }))

const calculatePasswordStrength = (password: string) => {
  const requirements = Object.entries(rules).map(([key, { regex, label }]) => ({
    key,
    label,
    isMet: regex.test(password)
  }))

  // enforcing minimum length requirement
  const hasMinLength = requirements.find((req) => req.key === 'minLength')?.isMet ?? false

  const baseStrength = requirements.reduce((acc, { isMet }) => acc + (isMet ? 20 : 0), 0)

  const strength = hasMinLength ? baseStrength : Math.min(baseStrength, 60)

  return {
    strength,
    requirements: requirements.map(({ label, isMet }) => ({ label, isMet }))
  }
}

export default calculatePasswordStrength
